import { render, staticRenderFns } from "./djglist.vue?vue&type=template&id=11930437&scoped=true"
import script from "./djglist.vue?vue&type=script&lang=js"
export * from "./djglist.vue?vue&type=script&lang=js"
import style0 from "./djglist.vue?vue&type=style&index=0&id=11930437&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11930437",
  null
  
)

export default component.exports